<template>
  <div class="quick-actions-slide">
    <div
      v-html="
        $t('text.home_landing_slide5_content', {
          patient: $store.state.locale.patient
        })
      "
      class="mb-15"
    ></div>
    <div
      v-for="action in quickActions"
      :key="action.title"
      class="quick-operate-item"
      @click="action.onClickAction(action.title)"
      v-show="p(action.permission)"
    >
      <div class="left-icon-wrapper v-h-center">
        <img
          :src="require('@/assets/image/quick-operation-icon/' + action.icon)"
          :style="{ width: action.iconWidth + 'px' }"
        />
      </div>
      <div class="right-content">
        <div class="quick-operate-title">{{ action.title }}</div>
        <div class="quick-operate-desc">{{ action.desc }}</div>
      </div>
    </div>

    <EditPatient ref="editPatient" />
    <InviteUserDialog ref="inviteUser" />
  </div>
</template>

<script>
import EditPatient from '@/components/manage/patients/EditPatient.vue'
import InviteUserDialog from '@/components/manage/user/InviteUserDialog.vue'
export default {
  data() {
    return {
      quickActions: [
        {
          title: this.$t('text.add_patient', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.add_patient_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.addPatient,
          icon: 'add-patient.png',
          iconWidth: 36,
          permission: 'Patients.Add'
        },
        {
          title: this.$t('text.invite_user'),
          desc:
            this.$t('text.invite_user_quick_action_desc_for_home_landing') +
            '.',
          onClickAction: this.inviteUser,
          icon: 'add-user.png',
          iconWidth: 39,
          permission: 'Users.Invite'
        }
      ]
    }
  },
  components: {
    EditPatient,
    InviteUserDialog
  },
  methods: {
    addPatient() {
      this.$refs.editPatient.openDialog()
    },
    inviteUser() {
      this.$refs.inviteUser.openDialog()
    }
  }
}
</script>

<style lang="scss" scoped>
ul li {
  cursor: pointer;
  text-decoration: underline;
  color: #409eff;
}
</style>
